import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogledomainsComponent } from './simple-icons-googledomains.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogledomainsComponent ],
    exports:      [ SimpleIconsGoogledomainsComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogledomainsModule {}
